<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <rect y="8" width="18" height="2" rx="1" fill="currentColor"/>
    <rect x="1.8" y="2" width="14.4" height="2" rx="1" fill="currentColor"/>
    <rect x="1.8" y="14" width="14.4" height="2" rx="1" fill="currentColor"/>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'NavigationMenu',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 18 18',
    },
  },
};
</script>

<style scoped>
  
</style>